import { render, staticRenderFns } from "./studentPrograms.vue?vue&type=template&id=2d72c416&scoped=true&"
import script from "./studentPrograms.vue?vue&type=script&lang=js&"
export * from "./studentPrograms.vue?vue&type=script&lang=js&"
import style0 from "./studentPrograms.vue?vue&type=style&index=0&id=2d72c416&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72c416",
  null
  
)

export default component.exports